






































































































































































import Vue from 'vue'
import { Company, Location, CloneAccount, TwilioAccount, Contact, Campaign, User } from '@/models'
import { mapState } from 'vuex'
import { CompanyState, UserState } from '@/store/state_models'
import vSelect from 'vue-select'
import { trackGaPageView } from "@/util/helper";

import PhoneNumber from './PhoneNumber.vue';
declare var $: any;

export default Vue.extend({
  components: { vSelect, PhoneNumber },
  data() {
    return {
      saving: false,
      submitted: false,
      calendarSkipped: false,
      calendarHeight: 560,
      currentSlide: 1,
      previousProduct: '',
      previousProductCustom: '',
      niche: '',
      clientCount: '',
      customNiche: '',
      campaignNumber: '',
      campaignEmail: '',
      userCalendarQuery: '',
      accountSID: '',
      authToken: '',
      errorMessage: '',
      calendarType: 'normal',
      clientOptions: [' < 5', '5 - 20', '21 - 50', ' > 50'],
      previousProductsOptions: [
        'Not using any other product',
        'Not listed',
        "Active Campaign",
        "Autopilot",
        "Click funnels",
        "Constant Contact",
        "Contact Smarter",
        "Drip",
        "Follow Up Boss",
        "Follow Up Edge",
        "GetResponse",
        "Hub Spot",
        "InfusionSoft",
        "Marketo",
        "Mautic",
        "Ontraport",
        "Prospect.io",
        "SendinBlue"
      ],
      nicheOptions: [
        'No Niche',
        'Not listed',
        'Accountants',
        'Accountants/CPAs',
        'Accounting & Tax Consultants',
        'Accounting, Auditing, & Bookkeeping Services',
        'Accounts Receivable Loans',
        'Administrative & Governmental Law Attorneys',
        'Adoption Attorneys',
        'Air Conditioning/Heating',
        'Annuities',
        'Appeals Attorneys',
        'Arbitration & Mediation Services Attorneys',
        'Asbestos Diseases Attorneys',
        'Auto Financing',
        'Auto Repair',
        'Auto dealers',
        'Bail Bonds',
        'Bail Bonds Referral Services',
        'Bail Bondsmen',
        'Banking & Investment Law Attorneys',
        'Bankruptcy',
        'Bankruptcy Lawyers',
        'Bankruptcy Services',
        'Banks',
        'Bathroom Remodeling',
        'Bookkeeping Services',
        'Business Financing',
        'Business Formation',
        'Business Insurance',
        'Business Valuators',
        'Car',
        'Car Rental',
        'Carpet Cleaners',
        'Carpet Cleaning',
        'Carpet Installation',
        'Carpet Stores',
        'Carpet, Rug, & Upholstery Services',
        'Carpet, Rug, & Upholstery Storage & Repair',
        'Carpets & Rugs Wholesale & Manufacturers',
        'Cash Advances',
        'Catering',
        'Check Cashing',
        'Child care',
        'Chiropractors',
        'Collection Agencies',
        'Consultants',
        'Cosmetic Surgery',
        'Day spas',
        'Decks & Porches',
        'Dental',
        'Dermatologists',
        'Dieticians',
        'Disc Jockeys',
        'Divorce Lawyers',
        'Estate Attorneys',
        'Estate Planning',
        'Fencing',
        'Financial Planners',
        'Flooring',
        'Florists',
        'Foreclosure/Short Sale',
        'Foreign Currency Exchange & Brokers',
        'General Contractors',
        'Glass repair',
        'Gyms',
        'HR Specialists',
        'Hair salons',
        'Handyman',
        'Health',
        'Heating And Cooling',
        'Home Appraisers',
        'Home Inspectors',
        'Home Theater Services',
        'Housekeeping/Maid Services',
        'Income Tax Services',
        'Independent Agents',
        'Interior Designers',
        'Jewelry Appraisers',
        'Karate',
        'Kitchen Remodeling',
        'Landscaping',
        'Lawyers',
        'Life',
        'Limousine',
        'Locksmiths',
        'Massage Therapists',
        'Mortgage Brokers',
        'Motorcycle dealers',
        'Movers',
        'Nail salons',
        'Painters',
        'Personal Chefs',
        'Personal Financial Services',
        'Personal Financing',
        'Personal Injury',
        'Personal Injury Lawyers',
        'Personal Insurance',
        'Personal Loans',
        'Personal Trainers',
        'Pest Control',
        'Pet groomers',
        'Photography/Videography',
        'Plumbers',
        'Pools & Spas',
        'Private schools',
        'Real Estate Investors',
        'Realtors',
        'Resorts',
        'Restaurants',
        'Roofing',
        'Security Systems',
        'Siding',
        'Small non chain hotels',
        'Tanning',
        'Tattoo shops',
        'Technical training centers',
        'Timeshares',
        'Travel Agents',
        'Veterinarians',
        'Vocational training',
        'Weddings',
        'Weight loss specialists',
        'Window Tinting'
      ],
      loading: {
        locations: false
      }
    }
  },
  watch: {
    company() {
      this.showOrHideModal(); // This method can called from some other better place as well. High run-time execution here.
      // Prefilling onboarding info, if already exists.
      // TODO: Enable only one time, not every time.
      if(this.company.onboardingInfo.client_count){
        this.clientCount = this.company.onboardingInfo.client_count;
      }
      if(this.company.onboardingInfo.previous_product){
        this.previousProduct = this.company.onboardingInfo.previous_product;
      }
      if(this.company.onboardingInfo.niche){
        this.niche = this.company.onboardingInfo.niche;
      }
      // jumping directly to the next step.
      if(this.company.onboardingInfo.completed_step < 3 && this.submitted === false && this.company.onboardingInfo.pending === true){
        this.currentSlide = this.company.onboardingInfo.completed_step;
        this.nextAction();
	    }
      // Create default location, if test-agency.
      // if(this.company.status === 'active_test-agency'){
      //   window.setTimeout( ()=>{
      //     this.createDefaultLocationWithCampaign();
      //   }, 5000);
      // }
    },
  },
  computed: {
    ...mapState('company', {
      company: (s: CompanyState): Company | undefined => {
        return s.company ? new Company(s.company) : undefined
      }
    }),
    user() {
      const user: UserState = this.$store.state.user.user
      return user ? new User(user) : undefined
    },
  },
  mounted() {
    this.showOrHideModal();
  },
  methods: {
    jsonToQueryString(json) {
      return '&' +
          Object.keys(json).map(function(key) {
              return encodeURIComponent(key) + '=' +
                  encodeURIComponent(json[key]);
          }).join('&');
    },
    showOrHideModal() {
      if (this.company && this.company.onboardingInfo.pending === true && this.company.status !== 'active_test-agency' && this.user && this.user.type==='agency') {
        $(this.$refs.modal).modal({
          backdrop: 'static',
          keyboard: false
        })
        trackGaPageView('onb-started')
      } else $(this.$refs.modal).modal('hide')
      // jumping directly to the next step.
      if(this.company.onboardingInfo.completed_step < 3 && this.submitted === false && this.company.onboardingInfo.pending === true){
        this.currentSlide = this.company.onboardingInfo.completed_step;
        this.nextAction();
	    }
    },
    async fetchUserDetails(){
      if(this.user){
        this.campaignEmail = this.user.email;
        let userData = {
          first_name: this.user.firstName || '',
          last_name: this.user.lastName || '',
          full_name: this.user.fullName || '',
          email: this.user.email || '',
          phone: this.user.phone || ''
        }
        this.userCalendarQuery = this.jsonToQueryString(userData);
      }
    },
    iframeLoaded(){
      window.addEventListener('message', this.handleIframeMessage)
    },
    async handleIframeMessage(e){
      if(e.data[0] === 'msgsndr-booking-complete') {
        trackGaPageView('onb-appt-confirmed');
        this.nextAction();
      }
      if(e.data[0] === 'highlevel.setHeight'){
        this.calendarHeight = e.data[1].height;
      }
    },
    async nextAction() {
      this.errorMessage = "";
      this.submitted = true;
      await this.fetchUserDetails();
      switch(this.currentSlide) {
        case 1:
          trackGaPageView('onb-survey-step-1');
			    this.saving = true;
          const p1 = this.updateOnboardingInfo();
          let allPromises = [p1];
          await Promise.all([...allPromises]);

          // const nextStep = await this.defineCalendarType();
          const nextStep = 2;

          this.saving = false;
          this.currentSlide = nextStep;
          break;
        case 2:
          await this.updateOnboardingInfo();
          this.currentSlide = 3;
          break;
        case 3:
          this.saving = true;
          trackGaPageView('onb-survey-completed');
          const locationId = await this.createDefaultLocation();
          await this.createDefaultCampaign( locationId );
          $(this.$refs.modal).modal('hide');
          await this.updateOnboardingInfo();
          // Redirecting to dashboard
          this.saving = false;
          this.$router.replace({ name: 'dashboard', params: { location_id: locationId } });
			    break;
      }
    },
    // async initTwilio(){
    //   this.twilioAccount = await TwilioAccount.getByCompanyId(this.company.id);
    //   if (!this.twilioAccount) {
    //     this.twilioAccount = new TwilioAccount();
    //     this.twilioAccount.companyId = this.company.id;
    //   } else {
    //     this.accountSID = this.twilioAccount.accountSID;
    //     this.authToken = this.twilioAccount.token;
    //   }
    // },
    async updateOnboardingInfo(){
      // onboarding params, step1
      const step = this.currentSlide;
      const params: {[key: string]: any} = {
        client_count: this.clientCount,
        niche: this.customNiche || this.niche,
        previous_product: this.previousProductCustom || this.previousProduct,
      };
      // Saving onboarding info
      // const fsCompany = await Company.getById(this.company.id);
      // fsCompany.onboardingInfo = {...params, completed_step: step, pending: (step < 3)? true : false};
      // await fsCompany.save();

      await Company.collectionRef().doc(this.company.id).update({
        onboarding_info:{
          ...params,
          completed_step: step,
          pending: (step < 3)? true : false
        }
      })
      // Adding onboarding info to the contact collection.
      if (this.currentSlide === 2 && this.calendarType === 'special'){
        params['new_tag'] = this.calendarSkipped ? 'free 1on1 skipped' : 'free 1on1 offered';
      } else if (this.currentSlide === 2 && this.calendarType === 'normal' && this.calendarSkipped) {
        params['new_tag'] = 'onboarding calendar skipped';
      }
      // if (this.currentSlide === 3) {
      //   params['new_tag'] = 'nboarding complete';
      // }
      try { // might fail due to 401 [an-authorized]
        await this.$http.post('/onboarding', params);
      } catch (err) {
        console.error('Failed to update onboarding-info in smart-list !!', err);
      }
    },
    async createDefaultLocation(){
      // Creating new blank location
      const location = new Location();
      location.name = this.company.name || 'Default account';
      location.companyId = this.company.id;
      location.timezone = this.company.timezone;
      location.phone = this.campaignNumber || this.user.phone;
      location.email = this.campaignEmail || this.user.email;
      location.status = "account";
      await location.save();
      // Initializing default location with default snapshot
      try {
        // await CloneAccount.hydrateWithData(location.id, this.selectedSnapshot.data);
        const snapshotType = 'default';
        await this.$http.post(`/snapshot/${snapshotType}/load_bg/${location.id}`, {
          snapshotType: snapshotType
      })
      } catch(err) {
        console.error(err);
      }
      return location.id;
    },
    async createDefaultCampaign (locationId: string) {
      try{
        // Adding user to a default onboarding campaign.
        let response = await this.$http.post('/onboarding/campaign', {
          location_id: locationId,
          first_name: this.user.firstName,
          last_name: this.user.lastName,
          name: this.user.fullName || 'New User',
          email: this.campaignEmail,
          phone: this.campaignNumber
        });
      }catch (err) {
        console.error(err);
      }
    },
    async createDefaultLocationWithCampaign () {
      this.loading.locations = true
      let locations = await this.$store.dispatch('locations/getAll')
      this.loading.locations = false
      if(locations.length === 0){
        const locationId = await this.createDefaultLocation();
        await this.createDefaultCampaign( locationId );
      }
    },
    async skipStep2(){
      this.calendarSkipped = true;
      trackGaPageView('onb-appt-skipped');
      this.nextAction();
    },
    async defineCalendarType(){
      // checking if already 1-on-1
      try{
        let charges = await this.$http.get("/api/stripe/charges");
        let receipts = charges ? charges.data.filter( receipt => receipt.paid === true) : [];
        let recieptIndex = receipts.findIndex( x => x.description === '$97 Concierge 1-on-1');
        if (recieptIndex !== -1) {
          // moving to the next step.
          // console.log("Already paid for $97 Concierge 1-on-1");
          this.calendarSkipped = true;
          return 3;
        }
      } catch (e) {
      }
      // setting the calendar type
      if (['21 - 50', ' > 50'].includes(this.clientCount)) {
        this.calendarType = 'special';
      } else if(this.company.stripeActivePlan) {
        const planName = this.company.stripeActivePlan.split('_')[2];
        if (planName === '297'){
          this.calendarType = 'special';
        }
      } else { // fetching in runtime
        try {
          let activePlan = await this.$http.get(`/api/stripe/agency_plan?company_id=${this.company.id}`);
          if(activePlan.data && activePlan.data.plan && activePlan.data.plan.name){
            const planName = activePlan.data.plan.name.split("_")[2];
            if (planName === '297'){
              this.calendarType = 'special';
            }
          }
        } catch (e) {
          // this.loading = false;
        }
      }
      return 2;
    }
  },
  beforeDestroy() {
    window.removeEventListener('message',this.handleIframeMessage);
  },
})
